import React from "react";

export enum ToastTypes {
  warning = "warning",
  success = "success",
}
export interface ToastProps {
  message: string;
  type: ToastTypes;
  show: boolean;
  dismiss: () => void;
  dismissable?: boolean;
}
